module.exports = __webpack_public_path__ + "assets/21f734782a2c7ae6125204914769496e.png";